import * as React from 'react'

function BirthdayBanner({ className, ...props }) {
  return (
    <svg className={className} viewBox="0 0 193 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 0C8.79086 0 7 1.79086 7 4V10L0 16L7 22V28C7 30.2091 8.79086 32 11 32H189C191.209 32 193 30.2091 193 28V4C193 1.79086 191.209 0 189 0H11Z"
        fill="#041333"
      />
    </svg>
  )
}

export default BirthdayBanner
